export class DocumentLibraryConstants {
  static readonly DISABLED_INPUT_TOOLTIP =
    'This field can not be edited because it was uploaded from another part of the application';
}
